import { Modal } from 'antd';
import { DARK } from '../../styles/styleUtils';
import { getImage, getTranslated } from '../../utils/CommonUtils';

/**
 * 
 * @param {String} type [confirm | error | info | warning] confirm is selected as default
 * @param {object} props Other possible params for the modal popup 
 */

// Function(not component) to show Confirm modal popup
const confirmModal = ({ type = "confirm", ...props }) => {

    Modal[type]({
        className: "confirm-modal",
        title: <span style={{ color: DARK }}>{getTranslated(null, props.title)}</span>,
        content: <span style={{ fontSize: "0.8em" }}>{getTranslated(null, props.content)}</span>,
        icon: <img src={getImage(props.icon || (type === "info" ? "icon_info.svg" : "icon_warning.svg"))} alt={`${type} icon`} style={{ height: "2em" }} />,
        width: props.width || 400,
        okText: getTranslated(null, props.okText || "LABEL_YES"),
        cancelText: getTranslated(null, props.cancelText || "LABEL_CANCEL"),
        closable: props.closable ?? false,
        // footer: footer ?? "",
        onOk() {
            props.onOk && props.onOk()
        },
        onCancel() {
            props.onCancel && props.onCancel()
        },
    })
}

export default confirmModal
